<template>
	<div class="deleteEmployers">
		<!-- Main Body Content area -->
        <div class="o-main-content-area">
            <!-- Heading Section -->
            <div class="row c-responsive-fixwidth">
                <div class="col-md-3">
                    <h1 class="h1">Employer</h1>
                </div>
                <div class="col-md-9 text-right">
                    <ul class="o-filter-area">

                        <!-- <li class="o-search-field">
                            <div class="input-group stylish-input-group">
                                <input type="text" class="form-control" placeholder="Search">
                                <span class="input-group-addon">
                                    <button type="submit">
                                    <span class=""><i class="fa fa-search" aria-hidden="true"></i></span>
                                </button>
                                </span>
                            </div>
                        </li> -->
                        <!-- <li><a @click="goToAddEmployer()" class="c-common-btn c-common-btn--green"><i class="fa fa-plus" aria-hidden="true"></i> Add new Employer</a></li> -->

                        <li><a href="javascript: void(0)" @click="deleteEmployers()" class="c-common-btn c-common-btn--red"><i class="fa fa-trash-o" aria-hidden="true"></i> Delete Employer</a></li>

                        <!-- <li><a href="#" class="c-common-btn c-solid-btn--blue"><i class="fa fa-upload" aria-hidden="true"></i> Import Through CSV</a></li> -->
                    </ul>

                </div>
            </div>
            <!-- /Heading Section -->
        </div>
        <div class="o-ndividualArea c-responsive-fixwidth">
            <div class="o-ndividualTable">
                <div class="c-common-space o-individual-calls">
                    <div class="col-md-12 o-no-padding">
                        <form class="form-inline">
                            <div class="form-group">
                                <label class="common-label-text">Sort By:</label>
                                <div class="o-cutsomSelect o-cutsomSelect--fixedwidth">
                                    <select class="" @change="sortEmployer()" v-model="selectedSortType">
                                    <option value="name">Name</option>
                                    <option value="email">Email</option>
                                  
                                </select>
                                </div>
                            </div>
<!--                            <button type="submit" class="c-common-btn c-common-btn--green">Go</button>-->
                        </form>
                    </div>
                </div>

                <div class="c-common-space o-individual-calls o-no-margin-bottom">
                    <div class="col-md-12 o-no-padding">
                        <form class="form-inline">
                            <div class="form-group">
                                <label class="common-label-text">Select:</label>
                                <button @click="selectAllEmployer()" class="c-common-btn c-common-btn--small o-no-side-margin" :class="(selectedFilter == 'all')?'o-filter-active':''">All</button>
                            </div>
                            <button @click="selectNone()" class="c-common-btn c-common-btn--small o-no-side-margin" :class="(selectedFilter == 'none')?'o-filter-active':''">None</button>
                            
                        </form>
                    </div>
                </div>

                <div class="o-skills-listing">
                    <div class="row">

                        <div class="col col-sm-12">
                           <div class="o-scheduleTable--daily">

                                <div v-for="employer in employers" class="o-calls-table c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10 employer-list-table-align employer-list-dlt">
                                        <div class="calls-table-row">
                                            <div class="calls-table-cell">
                                                <div class="checkbox o-custom-radio">
                                                    <label>
                                                        <input type="checkbox" name="04" :value="employer.hiring_organization_id" v-model="selectedEmployerId">
                                                        <!-- <input type="checkbox" name="o4" :value="employer.hiring_organization_id" checked=""> -->
                                                        <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                                    </label>
                                                </div>
                                            </div>

                                            <div class="calls-table-cell">
                                                <div class="table-td-border-right">
                                                    <div class="calls-table-cell-inner-table o-modal-trigger" data-toggle="modal" data-target="#employeeSummaryModal">
                                                        <div class="o-accordion-subtext user-icon o-delete-list-align">
                                                            <div class="o-post-logged o-post-logged--table-user">
                                                                <div class="o-user-profile-img">
                                                                    <img v-if="employer.hiring_organization && employer.hiring_organization.hiring_entities && employer.hiring_organization.hiring_entities[0].user.image != '' && employer.hiring_organization.hiring_entities[0].user.image != 'NULL'" :src="(employer.hiring_organization.hiring_entities[0].user.image)" id='img-upload' />
                                                                    <img v-if="employer.hiring_organization && employer.hiring_organization.hiring_entities &&  employer.hiring_organization.hiring_entities[0].user.image == '' || employer.hiring_organization.hiring_entities[0].user.image == 'NULL'" src="static/assets/images/user1.png" id='img-upload' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="o-accordion-subtext o-rowtable-text">
                                                            <span>Name</span>
                                                            <div>{{employer.hiring_organization.name}}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="calls-table-cell">
                                                <div class="table-td-border-right">
                                                <div class="calls-table-cell-inner-table">
                                                    <div class="o-accordion-subtext o-rowtable-text">
                                                        <span>Contact:</span>
                                                        <div>{{(employer.hiring_organization.contact_person_one!="") ? employer.hiring_organization.contact_person_one : "NA"}}</div>
                                                        <div v-if="employer.hiring_organization.contact_person_two!=''">{{employer.hiring_organization.contact_person_two}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell">
                                            <div class="table-td-border-right">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Email ID:</span>
                                                    <div>{{(employer.hiring_organization.email !="") ? employer.hiring_organization.email : "NA"}}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell">
                                            <div class="table-td-border-right">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Phone:</span>
                                                    <div>{{getPhoneNumber(employer.hiring_organization.phones)}}</div>
                                                    <!-- <div>(954) 918-7765</div> -->
                                                </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell">
                                            <div class="table-td-border-right">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>FAX:</span>
                                                    <div>(954) 918-7765</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
        <!-- /Main Body Content area -->
	</div>
</template>
<script>
    import dateTimeConvert from '../../timeConvert&Compare';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import {
        global
    } from '../../global.js';
    import service from '../../services.js';

    export default {
        data() {
            return {
                data: '',
                employers: [],
                getBaseURL: '',
                selectedEmployerId: [],
                selectedFilter: 'none',
                selectedSortType: 'name',
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                jobID: 'selectedJobId',
            })
        },
        methods: {
            sortEmployer() {
                let self = this;
                //console.log(this.employees, this.selectedSortType);
                switch (this.selectedSortType) {
                    case 'name':
                        this.employers.sort(function(a, b) {
                            if (a.hiring_organization.name < b.hiring_organization.name) return -1;
                            if (a.hiring_organization.name > b.hiring_organization.name) return 1;
                            return 0;
                        });
                        //console.log('Short By Name');
                        break;
                        /* case 'sen':
                             this.employers.sort(function(a, b) {
                                 if (a.seniority < b.seniority) return -1;
                                 if (a.seniority > b.seniority) return 1;
                                 return 0;
                             });
                             break;*/
                    case 'email':
                        this.employers.sort(function(a, b) {
                            if (a.hiring_organization.email < b.hiring_organization.email) return -1;
                            if (a.hiring_organization.email > b.hiring_organization.email) return 1;
                            return 0;
                        });
                        break;
                    default:
                        //console.log("default case..");
                }
            },
            deleteEmployers() {
                if(this.selectedEmployerId.length != 0){
                    this.$confirm('COMPANY will be removed the the records of CLIENT. Continue?', 'Warning', {
                        confirmButtonText: 'OK',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                    }).then(() => {
                        service.post('hiring-organization/deleteBulk', {
                            'hiring_organization_ids': JSON.stringify(this.selectedEmployerId)
                        }, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID
                        }).
                        then((res) => {
                            this.$Progress.finish();
                            this.$message({
                                type: 'success',
                                message: 'Delete completed'
                            });
                            this.grtAllEmployeer();
                        }).catch((err) => {
                            console.log(err);
                        });
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: 'Delete canceled'
                        });
                    });
                }else{
                    this.$message({
                        type: 'info',
                        message: ' Please Select employer from list.'
                    });
                }
                    
            },
            selectAllEmployer() {
                this.selectedFilter = 'all';
                let self = this;
                this.employers.forEach(function(employer) {
                    self.selectedEmployerId.push(employer.hiring_organization_id);
                    //console.log(emp.employable.id);
                });
            },
            selectNone() {
                this.selectedFilter = 'none';
                this.selectedEmployerId = [];
            },
            goToAddEmployer() {
                this.$router.push({
                    path: `/addEmployer`
                });
            },
            getPhoneNumber(phones) {
                //console.log(phones);
                if (phones.length > 0) {
                    return ("(" + phones[0].phone_number.substr(0, 3) + ") " + phones[0].phone_number.substr(3, 3) + "-" + phones[0].phone_number.substr(6));
                } else
                    return "NA";
            },
            grtAllEmployeer() {
                this.$Progress.start();
                service.get('hiring-organization/getHiringOrganizationByClient', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                }).
                then((res) => {
                    this.employers = res.data.result;
                    this.sortEmployer();
                    //console.log('employer', this.employers);
                    this.$Progress.finish();
                    //console.log("delete list", this.employers);

                }).catch((err) => {
                    console.log(err);
                });
            }
        },

        beforeMount() {
            this.getBaseURL = global[0].IMAGE_URL;
            this.grtAllEmployeer();

        }
    }

</script>



// WEBPACK FOOTER //
// src/components/employers/deleteEmployers.vue